import { Flex, Text } from '@chakra-ui/react'
import { LucideIcon } from 'lucide-react'
import React, { useState } from 'react'
import { CustomTooltipContainer } from '~/components/shared/CustomTooltip/CustomTooltipContainer'
import { Popover, PopoverAnchor, PopoverContent } from '~/components/ui/popover'

type TypeBadgeProps = {
  Icon: LucideIcon
  iconColor: string
  bg: string
  alt: string
  tooltip?: string
  popoverContent?: React.ReactNode
}

export const TypeBadge = ({
  Icon,
  iconColor,
  bg,
  alt,
  tooltip,
  popoverContent,
}: TypeBadgeProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} positioning={{ placement: 'bottom-start' }}>
      <PopoverAnchor>
        <Flex
          alignItems="center"
          justifyContent="center"
          height="1.5rem"
          minHeight="1rem"
          py="0.625rem"
          px="0.5rem"
          gap="0.375rem"
          borderRadius="0.375rem"
          bg={bg}
          onMouseEnter={
            tooltip || popoverContent ? () => setOpen(true) : undefined
          }
          onMouseLeave={
            tooltip || popoverContent ? () => setOpen(false) : undefined
          }
        >
          <Icon
            size={16}
            color={iconColor}
            strokeWidth={2.5}
            aria-label={alt}
          />
        </Flex>
      </PopoverAnchor>
      {open && (
        <PopoverContent
          bg="transparent"
          shadow="none"
          border="none"
          p={0}
          css={{ '--popover-bg': 'transparent' }}
        >
          <CustomTooltipContainer>
            {popoverContent || <Text>{tooltip}</Text>}
          </CustomTooltipContainer>
        </PopoverContent>
      )}
    </Popover>
  )
}
